const slugify = require('slugify');

/**
 * @param {{ 
 * state: import('./clinics').State, 
 * metro: import('./clinics').Metro }} args
 * @returns {string}
 */
function getMetroUrl({ state, metro }) {
  const firstStoreWithUrlPath = metro.stores?.find(store => store.urlPath);
  
  if (!firstStoreWithUrlPath || !firstStoreWithUrlPath.urlPath) {
    throw new Error(`No urlPath found for metro: ${metro.name}. All stores should have urlPath property.`);
  }
  
  const urlParts = firstStoreWithUrlPath.urlPath.split('/');
  const metroUrl = urlParts.slice(0, -1).join('/');
  
  if (!metroUrl) {
    throw new Error(`Invalid urlPath format for metro: ${metro.name}. Expected format: /locations/state/metro/store`);
  }
  
  return metroUrl;
}

module.exports = getMetroUrl;